import React from 'react'
import { Outlet } from 'react-router-dom'

function MainEquipments() {
  return (
  <div>
        <Outlet/>
      </div>
  )
}

export default MainEquipments